<div class="container px-0 py-4 overflow-auto pointer" *ngIf="searches?.length">
  <h2 class="mb-3 fs-lg">شغل‌های درخواستی من</h2>
  <a class="d-block white-bg rounded-xl my-2 py-2 border border-medium-gray relative shadow-kp-sm d-flex flex-wrap"
    *ngFor="let search of searches" ga-event="my-search|{{search.SearchParams?.q}}"
    [href]="search.SearchParams._Url">
    <h3 class="fs-normal text-right m-0 pr-2 pl-1 flex-grow-1">{{search.SearchParams._searchTitle}}</h3>
    <div *ngIf="search.New" class="text-left fs-sm px-1 flex-grow-1">
      <span class="rounded-xl yellow-bg p-1">{{search.New}} فرصت شغلی {{search.Today ? 'امروز' : 'جدید'}} </span>
    </div>
    <i *ngIf="!search.New" class="fa fa-search pl-2 fs-normal abs-middle left-0"></i>
  </a>
</div>